var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestiicon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.751099,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#0675F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 46.0845C39.3639 46.0845 45.3334 40.1149 45.3334 32.7511C45.3334 25.3873 39.3639 19.4178 32.0001 19.4178C24.6363 19.4178 18.6667 25.3873 18.6667 32.7511C18.6667 40.1149 24.6363 46.0845 32.0001 46.0845Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24.7511V32.7511H26",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestiicon4);
export default __webpack_public_path__ + "static/media/destiicon4.a5acc25cf44dfc11b60c6f98680a204b.svg";
export { ForwardRef as ReactComponent };